import React, { useEffect, useState } from 'react';
import Apiservice from '../Apiservice';
import { useNavigate } from 'react-router-dom';

const AllSites = () => {
    const navigate = useNavigate();
    const [sites, setSites] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const data = { status: 0 };
                const result = await Apiservice.AllSites(data);

                if (result.success) {
                    setSites(result.data);
                } else {
                    setSites([]);
                }
            } catch (error) {
                console.error(error);
                setSites([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleAddSite = () => {
        navigate('/addsite')
    }

    const getCardStyle = (index) => ({
        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        borderRadius: '12px',
        border: hoveredIndex === index ? '1px solid #0d6efd' : '1px solid #e0e0e0',
        transform: hoveredIndex === index ? 'translateY(-5px)' : 'none',
        boxShadow:
            hoveredIndex === index
                ? '0 6px 20px rgba(0, 0, 0, 0.1)'
                : '0 2px 8px rgba(0, 0, 0, 0.05)',
    });

    return (
        <div className="container shadow ">
            <div className="row d-flex justify-content-between align-items-center mb-2 text-center sticky-top z-3">
                <h4 className="fw-bold text-primary">All Sites</h4>

            </div>
            <div className="row mb-2 sticky-top z-3">
                <div className="col text-end">
                    <button className="btn btn-success btn-sm" onClick={handleAddSite}>Add Site</button>
                </div>
            </div>

            <div className="row">
                {loading ? (
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted">Loading sites...</p>
                    </div>
                ) : sites.length > 0 ? (
                    sites.map((site, index) => (
                        <div className="col-md-6 col-lg-4 mb-4" key={index}>
                            <div
                                className="card h-100 bg-light"
                                style={getCardStyle(index)}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onDoubleClick={() => navigate(`/sitedetails/${site.id}`)}
                            >
                                <div className="card-body">
                                    <h5 className="card-title text-dark fw-bold">{site.name}</h5>
                                    {site.address.length > 0 && (
                                        <>
                                            <p className="mb-1 text-muted">
                                                {site.address[0].unitNo}, {site.address[0].street},
                                            </p>

                                            <p className="mb-1 text-muted">{site.address[0].country} - {site.address[0].pincode}</p>


                                        </>
                                    )}
                                    <p className="mb-1">
                                        <strong>Email:</strong> {site.emailId || 'N/A'}
                                    </p>
                                    <p>
                                        <strong>Contact:</strong> {site.countryCode + site.mobileNo}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col">
                        <p className="text-center text-muted">No sites available</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllSites;
